import script from "./SearchAttribute.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchAttribute.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__